module.exports = __webpack_public_path__ + "static/media/deleteIcon.3e5f6707.svg";